import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useRequestDemo } from '../utils/demo';

const RequestDemoForm = ({ closeDemoOpenDownload }) => {
  const { popupDemoSubmit, demoSuccess, demoError } = useRequestDemo();

  const [input, setInput] = useState({
    name: '',
    phone: '',
    email: '',
    companyName: '',
    companyType: 'Contractor',
    companySize: '1-50',
  });

  const inputChangeHandler = useCallback((e) => {
    const { name, value } = e.target;

    setInput((state) => ({ ...state, [name]: value }));
  }, []);

  const submitHandler = useCallback(
    (e) => {
      e.preventDefault();

      popupDemoSubmit(input, () =>
        setInput({
          name: '',
          phone: '',
          email: '',
          companyName: '',
          companyType: 'Contractor',
          companySize: '1-50',
        }),
      );
    },
    [input, popupDemoSubmit],
  );

  return (
    <form className="request-demo-form" onSubmit={submitHandler}>
      <div className="flex-row">
        <div className="col col-6">
          <div className="form-group">
            <label htmlFor="request-demo-name">
              Name*
              <input
                id="request-demo-name"
                type="text"
                name="name"
                placeholder="Enter Full Name"
                value={input.name}
                onChange={inputChangeHandler}
                required
              />
            </label>
          </div>
        </div>
        <div className="col col-6">
          <div className="form-group">
            <label htmlFor="request-demo-phone">
              Phone*
              <input
                id="request-demo-phone"
                name="phone"
                type="text"
                placeholder="+91 9999988888"
                value={input.phone}
                onChange={inputChangeHandler}
                required
              />
            </label>
          </div>
        </div>
        <div className="col col-6">
          <div className="form-group">
            <label htmlFor="request-demo-email">
              Email
              <input
                id="request-demo-email"
                type="email"
                name="email"
                placeholder="name@company.com"
                value={input.email}
                onChange={inputChangeHandler}
              />
            </label>
          </div>
        </div>
        <div className="col col-6">
          <div className="form-group">
            <label htmlFor="request-demo-company">
              Company Name*
              <input
                id="request-demo-company"
                type="text"
                name="companyName"
                placeholder="Enter Company Name"
                value={input.companyName}
                onChange={inputChangeHandler}
                required
              />
            </label>
          </div>
        </div>
        <div className="col col-6">
          <div className="form-group">
            <label htmlFor="request-demo-companytype">
              Company Type*
              <select
                id="request-demo-companytype"
                name="companyType"
                value={input.companyType}
                onChange={inputChangeHandler}
                required>
                {[
                  'Contractor',
                  'Subcontractor',
                  'Developer/Builder',
                  'Govt. Contractor',
                  'Others',
                ].map((i) => (
                  <option key={i} value={i}>
                    {i}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </div>
        <div className="col col-6">
          <div className="form-group">
            <label htmlFor="request-demo-companysize">
              Company Size*
              <select
                id="request-demo-companysize"
                name="companySize"
                value={input.companySize}
                onChange={inputChangeHandler}
                required>
                {[
                  '1-50',
                  '51-100',
                  '201-400',
                  '401-1000',
                  '1001-10000',
                  '10000+',
                ].map((i) => (
                  <option key={i} value={i}>
                    {i}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </div>

        <div className="col">
          <div className="form-group">
            <button type="submit" className="button">
              Request Demo
            </button>
          </div>
          {demoSuccess && (
            <small className="success-message">{demoSuccess}</small>
          )}
          {demoError && <small className="error-message">{demoError}</small>}
        </div>
      </div>

      <p>
        Want to get started?&nbsp;
        <button
          type="button"
          className="button-unstyled link-unstyled"
          onClick={closeDemoOpenDownload}>
          Download Powerplay app for free
        </button>
      </p>
    </form>
  );
};

RequestDemoForm.propTypes = {
  closeDemoOpenDownload: PropTypes.func.isRequired,
};

export default RequestDemoForm;
